"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionController = void 0;
const logger_1 = require("../../util/logger");
const domain_id_1 = require("@streem/domain-id");
const toolbox_1 = require("@streem/toolbox");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const take_first_emitted_1 = require("../../util/rx/take_first_emitted");
const utils_1 = require("../wall/utils");
class DetectionController {
    constructor(config) {
        this.config = config;
        this.streemshots = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('streemshot'), (0, utils_1.accumulateAndMapWallEvents)('streemshot'));
        this.streemshotDetections = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('streemshotDetections'), (0, utils_1.accumulateAndMapWallEvents)('streemshotDetections'), (0, operators_1.map)(streemshots => streemshots
            .flatMap(detections => {
            var _a, _b, _c;
            const streemshotSid = (_a = detections.streemshotId) !== null && _a !== void 0 ? _a : '';
            const streemshotDetections = (_c = (_b = detections.detections) === null || _b === void 0 ? void 0 : _b.map(det => (Object.assign(Object.assign({}, det), { streemshotSid })))) !== null && _c !== void 0 ? _c : [];
            return streemshotDetections;
        })
            .sort((a, b) => {
            if (a.type > b.type) {
                return -1;
            }
            else {
                return 1;
            }
        })), (0, operators_1.shareReplay)(1));
    }
    getDetections({ types, streemshotId, }) {
        let finalRx = (0, rxjs_1.combineLatest)([this.streemshotDetections, this.streemshots]).pipe((0, operators_1.map)(([detections, streemshots]) => {
            return detections
                .map((detection) => {
                const matchingStreemshot = streemshots.find((s) => s.id === detection.streemshotSid);
                (0, toolbox_1.invariant)(matchingStreemshot, 'Could not find matching streemshot for detection');
                return Object.assign(Object.assign({}, detection), { streemshotCreatedAt: matchingStreemshot.clientCreatedAt });
            })
                .sort((a, b) => {
                var _a, _b, _c, _d, _e, _f;
                return ((_c = (_b = (_a = a.streemshotCreatedAt) === null || _a === void 0 ? void 0 : _a.seconds) === null || _b === void 0 ? void 0 : _b.toNumber()) !== null && _c !== void 0 ? _c : 0) -
                    ((_f = (_e = (_d = b.streemshotCreatedAt) === null || _d === void 0 ? void 0 : _d.seconds) === null || _e === void 0 ? void 0 : _e.toNumber()) !== null && _f !== void 0 ? _f : 0);
            });
        }));
        if (types) {
            finalRx = finalRx.pipe((0, operators_1.map)(wallItems => wallItems.filter(item => types.includes(item.type))));
        }
        if (streemshotId) {
            finalRx = finalRx.pipe((0, utils_1.filterByProperty)('streemshotSid', streemshotId.toString()));
        }
        return finalRx;
    }
    // Creating a detection adds a userDetectionFeedback item to the wall. Streem service will see updates to this item and generate/update corresponding streemshotDetections as needed.
    createDetection(streemshotId, description, type) {
        logger_1.logger.debug(`Creating new detection for streemshot ${streemshotId}`);
        this.config.roomWall.createDetection(streemshotId, description, type);
    }
    updateDetection(detectionId, newDescription, newType) {
        return __awaiter(this, void 0, void 0, function* () {
            const detections = yield (0, take_first_emitted_1.takeFirstEmitted)(this.streemshotDetections);
            const detection = detections.find(x => x.detectionId === detectionId.toString());
            (0, toolbox_1.invariant)(detection, 'Could not find a detection to update');
            const streemshotId = new domain_id_1.StreemshotId(detection.streemshotSid);
            // Type can’t truly be changed/switched since the type is core to the detection
            // Only way to change type is to hide old detection & recreate new one
            logger_1.logger.debug(`Updating detection ${detectionId}`);
            if (detection.type !== newType) {
                this.config.roomWall.hideDetection(streemshotId, detectionId);
                this.config.roomWall.createDetection(streemshotId, newDescription, newType);
            }
            else {
                this.config.roomWall.updateDetection(streemshotId, detectionId, newDescription);
            }
        });
    }
    deleteDetection(detectionId) {
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.debug(`Hiding detection ${detectionId}`);
            const detections = yield (0, take_first_emitted_1.takeFirstEmitted)(this.streemshotDetections);
            const detection = detections.find(x => x.detectionId === detectionId.toString());
            (0, toolbox_1.invariant)(detection, 'Could not find a detection to delete');
            const streemshotId = new domain_id_1.StreemshotId(detection.streemshotSid);
            this.config.roomWall.hideDetection(streemshotId, detectionId);
        });
    }
}
exports.DetectionController = DetectionController;
//# sourceMappingURL=detection_controller.js.map